import React from "react";
import cx from "classnames";
import { ListItem, ListItemIcon, ListItemText, IconButton, Icon, Badge } from "@mui/material";
import ChatIcon from "@mui/icons-material/NavigateNext";
import TruncatedText from "../../chatTypes/team/components/TruncatedText";

const CHAT_TYPE_CLASS = {
  ai: "chat-type-ai",
  support: "chat-type-support",
  team: "chat-type-team",
};

const TOOLTIP_POPPER_PROPS = {
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [-2, 0],
      },
    },
  ],
};

const ChatsListItem = ({
  variant = "team",
  leading,
  title,
  subtitle,
  timestamp,
  onClick,
  unreadCount,
  disableChevron,
  customTrailing,
  className,
  contentClassName,
  titleClassName,
}) => {
  const renderUserName = () => {
    if (!title) return '';

    return (
      <ListItemText
        className={cx("chat-preview-body", contentClassName)}
        primaryTypographyProps={{
          component: "span",
          className: cx("chat-preview-title", titleClassName),
        }}
        secondaryTypographyProps={{ component: "span", className: "chat-preview-secondary" }}
        primary={
          <TruncatedText 
            text={title}
            tooltipPlacement="bottom"
            tooltipPopperProps={TOOLTIP_POPPER_PROPS}
          />
        }
        secondary={
          subtitle && (
            <span className="chat-preview-subtitle">
              {subtitle}
              {timestamp && <span className="chat-preview-timestamp">{timestamp}</span>}
            </span>
          )
        }
      />
    );
  };

  const renderTrailing = () => {
    if (customTrailing) {
      return customTrailing;
    }

    if (variant === "ai") {
      if (unreadCount) {
        return (
          <Badge color="primary" badgeContent={unreadCount} className="chat-preview-badge" />
        );
      }

      return (
        <IconButton size="small" className="chat-preview-action">
          <Icon>add</Icon>
        </IconButton>
      );
    }

    if (variant === "support") {
      if (unreadCount) {
        return (
          <Badge color="primary" badgeContent={unreadCount} className="chat-preview-badge" />
        );
      }

      return (
        <IconButton size="small" className="chat-preview-action">
          <Icon>add</Icon>
        </IconButton>
      );
    }

    if (disableChevron) return null;

    return (
      <IconButton edge="end" size="small" className="chat-preview-chevron">
        <ChatIcon />
      </IconButton>
    );
  };

  return (
    <ListItem
      className={cx("chat-preview", CHAT_TYPE_CLASS[variant], className)}
      onClick={onClick}
      alignItems="flex-start"
      disableGutters
      button
      sx={{ padding: "12px 16px", borderRadius: "12px" }}
    >
      {leading && (
        <ListItemIcon
          className={cx(
            "chat-preview-icon chat-icon",
            variant === "team" && "chat-preview-icon-avatar"
          )}
        >
          {leading}
        </ListItemIcon>
      )}
      {renderUserName()}
      {renderTrailing()}
    </ListItem>
  );
};

// Memoize to prevent unnecessary re-renders when parent updates
export default React.memo(ChatsListItem);
